module.exports = __webpack_public_path__ + "assets/img/5_1332.ff1f9268.jpg";